import { render, staticRenderFns } from "./I2DataLoading.vue?vue&type=template&id=1f4a3f14&scoped=true"
import script from "./I2DataLoading.vue?vue&type=script&lang=js"
export * from "./I2DataLoading.vue?vue&type=script&lang=js"
import style0 from "./I2DataLoading.vue?vue&type=style&index=0&id=1f4a3f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4a3f14",
  null
  
)

export default component.exports